import styled from 'styled-components';

export const TimerBannerStyled = styled.div`

  .timerBannerMains {
    background-color: rgb(255, 255, 255, 0.40);
    backdrop-filter: blur(64px);
    width: 392px;
    height: 90px;
    top: 170px;
    border-radius: 16px;
  }

  .timerBannerMainsDark {
    background-color: rgba(0, 0, 0, 0.40);
    backdrop-filter: blur(64px);
    width: 392px;
    height: 90px;
    top: 170px;
    border-radius: 16px;
  }

  .timerBannerSeconds {
    position: absolute;
    left: 17px;
    bottom: 80px;
    width: 111px;
    height: 24px;
    border-radius: 4px;
    background-color: rgb(255, 255, 255, 0.80);
  }

  .timerBannerSecondsDark {
    position: absolute;
    left: 17px;
    bottom: 80px;
    width: 111px;
    height: 24px;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.80);
  }

  .timerBannerLabel {
    width: 99px;
    height: 12px;
    padding-left: 12px;
    font: Montserrat;
    color: ${(props) => props?.theme?.color?.black};
    font-weight: 600;
    font-size: 13px;
    align-items: center;
    line-height: 12px;
  }

  .timerBannerLabelDark {
    width: 99px;
    height: 12px;
    padding-left: 12px;
    font: Montserrat;
    color: ${(props) => props?.theme?.color?.white};
    font-weight: 600;
    font-size: 13px;
    align-items: center;
    line-height: 12px;
  }

  .timeStyles {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    padding-top: 15px;
  }

  .timeStylesSecond {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .timeStylesThird {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .timeStylesLabel {
    font: Montserrat;
    font-weight: 700;
    color: ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['900']};
    font-size: 36px;
    line-height: 36px;
  }

  .timeStylesLabelDark {
    font: Montserrat;
    font-weight: 700;
    color: ${(props) => props?.theme?.color?.white};
    font-size: 36px;
    line-height: 36px;
  }

  .timeStylesLabelSecond {
    font: Mulish;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: ${(props) => props?.theme?.blue?.darkBlue};
  }

  .timeStylesLabelSecondDark {
    font: Mulish;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: ${(props) => props?.theme?.color?.smokeWhite};
  }

  .timeColonStyles {
    padding-bottom: 22px;
    margin-left: 15px;
    font: Montserrat;
    font-weight: 700;
    color: ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['900']};
    font-size: 36px;
    line-height: 36px;
  }

  .timeColonStylesDark {
    padding-bottom: 22px;
    margin-left: 15px;
    font: Montserrat;
    font-weight: 700;
    color: ${(props) => props?.theme?.color?.white};
    font-size: 36px;
    line-height: 36px;
  }
  
  @media (max-width: 480px) {
    .timerBannerMains {
      max-width: 60vw;
      max-height: 44px;
    }
    .timerBannerMainsDark {
      max-width: 60vw;
      max-height: 50px;
    }
    .timeStyles {
      padding-top: 0;
    }
    .timeStylesLabelDark {
      font-size: 16px;
      line-height: 16px;
    }
    .timeStylesLabel {
      font-size: 16px;
      line-height: 16px;
    }
    .timeStylesLabelSecondDark {
      font-size: 9px;
    }
    .timeStylesLabelSecond {
      font-size: 9px;
    }
    .timeColonStylesDark {
      font-size: 16px;
    }
    .timeColonStyles {
      font-size: 16px;
    }
    .timerBannerSeconds {
      max-height: 23px;
      max-width: 75px;
      bottom: 40px;
    }
    .timerBannerSecondsDark {
      max-height: 23px;
      max-width: 75px;
      bottom: 40px;
    }
    .timerBannerLabel {
      font-size: 9px;
      line-height: 9px;
      padding-left: 9px;
    }
    .timerBannerLabelDark {
      font-size: 9px;
      line-height: 9px;
      padding-left: 9px;
    }
  }

`;
